import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Loading, } from './components';
import zhCN from 'antd/es/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import { ConfigProvider } from 'antd';
import { createContext, useEffect, useMemo } from 'react';
import { getSystemNameMap } from './utils';
import { useSharedGlobalState } from './hooks/useSharedGlobal';
import moment from 'moment';
import { useWebSocket } from './components/Auth/Thing';
import { LubanAiFixed } from './layout/LubanAiFixed';
import { useGlobalTheme } from '@core/rc-components';
import { useGlobalPermissionState } from './hooks/useGlobalPermissionState';
import { useJfGlobalProject } from '@core/rc-state';
moment.locale('zh-cn');
export const WebsocketContext = createContext(undefined);
export const RouterContext = createContext({
    system: '',
    resourceList: [],
    routers: [],
    userinfo: {},
    prefix: '',
    systemName: '',
});
export const AppLayout = ({ routes: propsRoutes, authLoginType = 'KXGC', websocketParams, mode, system, documentTitlePrefix, children, isMenuUrlAddSystemName = true, antdConfigProvider, systemId }) => {
    const SYSTRM_NAME_MAP = getSystemNameMap();
    const { status } = useGlobalPermissionState(systemId || '', propsRoutes);
    const { changeTheme, requestTheme } = useGlobalTheme({ antdConfigProvider, ConfigProvider, authLoginType, manual: true });
    useJfGlobalProject({ initProject: true });
    const { startWsHandler } = useWebSocket({
        ...websocketParams,
        mode,
        authLoginType,
        onWebSocketConnected(data) {
            _initStateByKey('socketCtx', data);
        },
    });
    const { userinfoFromApiAll: userinfo, _initStateByKey, resourceList, systemName: globalSystemName, _initStateByObj, 
    // @ts-ignore
    isShowAi, } = useSharedGlobalState();
    if (!Array.isArray(propsRoutes) || !propsRoutes.length) {
        return _jsx(_Fragment, { children: "Cannot find routes" });
    }
    const systemName = useMemo(() => {
        if (!userinfo) {
            return documentTitlePrefix || SYSTRM_NAME_MAP['KXGC'];
        }
        const getSysName = globalSystemName;
        return getSysName;
    }, [globalSystemName]);
    useEffect(() => {
        _initStateByObj({
            isMenuUrlAddSystemName,
            system,
            changeTheme
        });
    }, [isMenuUrlAddSystemName]);
    useEffect(() => {
        requestTheme();
        startWsHandler();
    }, []);
    return (_jsx(ConfigProvider, { locale: zhCN, children: _jsxs(RouterContext.Provider, { value: {
                routers: propsRoutes,
                resourceList,
                system,
                userinfo,
                prefix: documentTitlePrefix,
                systemName: systemName,
            }, children: [isShowAi ? _jsx(LubanAiFixed, { authLoginType: authLoginType, systemId: systemId }) : null, _jsx(_Fragment, { children: status === 'read' ? children : _jsx(Loading, {}) })] }) }));
};
